module.exports = __webpack_public_path__ + "img/message-grey.421217b.svg";